import { type PropsWithChildren } from "react";
import Footer from "@/layouts/footer/Footer";
import { StyledBaseLayout } from "@/layouts/styles";
import { StyledMain, StyledBackground } from "./LoginPageLayout.styles";

const LoginPageLayout = ({ children }: PropsWithChildren) => (
  <StyledBaseLayout>
    <StyledBackground />
    <StyledMain>{children}</StyledMain>
    <Footer />
  </StyledBaseLayout>
);

export default LoginPageLayout;
